import script from "./experimentInteraction.vue?vue&type=script&setup=true&lang=js"
export * from "./experimentInteraction.vue?vue&type=script&setup=true&lang=js"

import "./experimentInteraction.vue?vue&type=style&index=0&id=0986c124&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0986c124"]])

export default __exports__